"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeNodes = exports.reparentNodes = exports.isCEPolyfill = void 0;
exports.isCEPolyfill = typeof window !== 'undefined' &&
    window.customElements != null &&
    window.customElements.polyfillWrapFlushCallback !==
        undefined;
const reparentNodes = (container, start, end = null, before = null) => {
    while (start !== end) {
        const n = start.nextSibling;
        container.insertBefore(start, before);
        start = n;
    }
};
exports.reparentNodes = reparentNodes;
const removeNodes = (container, start, end = null) => {
    while (start !== end) {
        const n = start.nextSibling;
        container.removeChild(start);
        start = n;
    }
};
exports.removeNodes = removeNodes;
